module.exports = __webpack_public_path__ + "img/hands.45a33bf0.svg";